/**
 * main.js
 */
require.config({
    baseUrl: '../../..'
});

require(
        ['eservicesController', 'homeController'],
        function () {
            initializeCtrl();
        },
        function (err) {
            console.error("ERROR: ", err.requireType);
            console.error("MODULES: ", err.requireModules);
        }
);

define("main", function(){});

